export default {
  'menu.AnnouncementRecordListPage': '公告列表',

  // GENERATOR_KEEP_DO_NOT_DELETE_THIS_LINE
};
